import axios from "axios";
import store from "@/main.js"

axios.defaults.withCredentials = true
axios.interceptors.response.use((response) =>
{
    return response
},
function (error)
{
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry)
    {
        originalRequest._retry = true;
        return axios.post('/refresh', {refreshToken: store.state.refreshToken})
        .then(res =>
        {
            if (res.status === 200)
            {
                return axios(originalRequest);
            }
        });
    }
    else if (error.response.status === 403)
        store.state.name = "" // token outdated or some other severe error -> logout user

    // return Error object with Promise
    return Promise.reject(error);
});

if (location.port == "8080")
    axios.defaults.baseURL = location.protocol + "//" + location.hostname + ":5000/v1.0/"
else
    axios.defaults.baseURL = location.protocol + "//" + location.host + "/api/v1.0/"

export default
{
    generateDownloadCategoryAdUrl(pharmacy, ad)
    {        
        return (axios.defaults.baseURL + "downloadAd?pharmacy=" +pharmacy+ "&ad="+encodeURIComponent(ad));
    },

    generatePicUrl(pic)
    {        
        return (axios.defaults.baseURL + "downloadPic?pic="+encodeURIComponent(pic));
    },

    generateDownloadAdUrl(pharmacy, ad)
    {
        const slash = ad.lastIndexOf('/');
        const fname = ad.slice(slash+1)
        return (axios.defaults.baseURL + "downloadAd?pharmacy=" +pharmacy+ "&ad="+encodeURIComponent(fname));
    },

    downloadTicket(ticket)
    {
        const a = document.createElement('a');
        a.href = axios.defaults.baseURL+"downloadFile?ticket="+ticket
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    },

    downloadFile(file, folder, customerId)
    {
        return axios.post("/download",
        {
            file: file,
            folder: folder,
            customerId: customerId,
            language: store.state.locale
        });
    },

    deleteFile(file, folder, customerId)
    {
        return axios.post("/deleteFile",
        {
            file: file,
            folder: folder,
            customerId: customerId,
            language: store.state.locale
        });
    },

    uploadFile (formData)
    {
        return axios.post( '/upload', formData,
        {
            headers:
            {
                'Content-Type': 'multipart/form-data',
                'X-Vabiz-Language': store.state.locale
            }
        });
    },

    login(user, pass)
    {
        return axios.post("/login",
        {
            user: user,
            pass: pass,
            language: store.state.locale
        });
    },

    logout()
    {
        return axios.post("/logout");
    },

    getSettings(setting)
    {

        return axios.post("/settings",
        {
            setting: setting,
            language: store.state.locale
        });
    },

    getCatalogs(catalog)
    {
        return axios.post("/catalogs",
        {
            catalog: catalog,
            language: store.state.locale
        });
    },

    getRecords(table, page=1, pageSize=100, search="", sortBy, sortDesc, parentId)
    {
        if (table === "files")
        {
            return axios.post("/files",
            {
                page: page,
                pageSize: pageSize,
                search: search,
                sortBy: sortBy,
                sortDesc: sortDesc,
                language: store.state.locale
            });
        }
        else
        {
            return axios.post("/records",
            {
                table: table,
                page: page,
                pageSize: pageSize,
                search: search,
                sortBy: sortBy,
                sortDesc: sortDesc,
                parentId: parentId,
                language: store.state.locale
            });
        }
    },

    exportTicket(ticket)
    {
        const a = document.createElement('a');
        a.href = `${axios.defaults.baseURL}exportFile?ticket=${ticket}&language=${store.state.locale}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    },

    exportRecords(table, search="", sortBy, sortDesc, parentId=null, page=null, pageSize=null)
    {        
        return axios.post("/export",
        {
            table: table,
            page: page,
            pageSize: pageSize,
            search: search,
            sortBy: sortBy,
            sortDesc: sortDesc,
            parentId: parentId,
            language: store.state.locale
        });
    },

    changePassword(password)
    {
        return axios.post("/update",
        {
            table: "password",
            data: [{value:"password", model:password}],
            language: store.state.locale
        });
    },

    saveRecord(table, data)
    {
        let toSave = [];
        for (let d of data)
        {
            if (d.value !== "actions" && d.value !== "id")
                toSave.push(d)
            if (d.value === "id" && d.model != "")
                toSave.push(d)
        }

        if (toSave[0].value == "id")
        {
            const id = toSave[0].model;
            toSave.shift()
            return axios.post("/update",
            {
                table: table,
                data: toSave,
                id: id,
                language: store.state.locale
            });
        }
        else
        {
            return axios.post("/create",
            {
                table: table,
                data: toSave,
                language: store.state.locale
            });
        }
    },

    deleteRecord(table, id)
    {
        return axios.post("/delete",
        {
            table: table,
            id: id,
            language: store.state.locale
        });
    }
};
